import { Controller, useFormContext } from "react-hook-form";

import { InputError } from "@/components/primitives/InputError";
import { Input } from "@/components/primitives/input";
import { Hidden } from "@/integrations/forms";

export default function FormHiddenInput({ field }: { field: Hidden }) {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { name, inputProps } = field;
  const error = errors?.[name]?.message;

  return (
    <div>
      <Controller
        control={control}
        defaultValue={field.value}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            onBlur={onBlur}
            onChange={(v: any) => onChange(v)}
            value={value}
            type="hidden"
            name={field.name}
            {...inputProps}
          />
        )}
        rules={{ required: true }}
        name={name}
      />
      {!!error && (
        <InputError className="mt-1">
          <>{error}</>
        </InputError>
      )}
    </div>
  );
}
